import { render } from "./ArticleEdit.vue?vue&type=template&id=3f1f2f6c&scoped=true"
import script from "./ArticleEdit.vue?vue&type=script&lang=js"
export * from "./ArticleEdit.vue?vue&type=script&lang=js"

import "./ArticleEdit.vue?vue&type=style&index=0&id=3f1f2f6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1f2f6c"]])

export default __exports__